import { SymbolType } from '../../../../domain/symbol.domain';

export abstract class SimpleCreateOrderForm {
  securityType: SymbolType;
  symbolType: SymbolType | Array<SymbolType>; // applicable to stock, option and mf
  orderItemIndex: number;

  getSecurityType(): SymbolType {
    return this.securityType;
  }
}

